import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { chipProps, chipEmits } from './chip';


export default /*#__PURE__*/_defineComponent({
  __name: 'chip',
  props: chipProps,
  emits: chipEmits,
  setup(__props, { emit: emits }) {

const props = __props




return { __sfc: true,props, emits }
}

})